import moment from "moment";

export const SERVER_DATE_FORMAT = "YYYY-MM-DD";

export const findTimelineGroupForDate = (timelineArray = [], dateString) => {
    if (!Array.isArray(timelineArray)) return null;
    const target = moment(dateString, SERVER_DATE_FORMAT);
    return (
        timelineArray.find((group) => {
            if (!group?.dateGroup) return false;
            const parsed = moment(group.dateGroup, ["DD-MM-YY", "DD-MM-YYYY"], true);
            if (!parsed.isValid()) {
                const parsedLoose = moment(group.dateGroup, ["DD-MM-YY", "DD-MM-YYYY"]);
                return parsedLoose.isValid() && parsedLoose.isSame(target, "day");
            }
            return parsed.isSame(target, "day");
        }) || null
    );
};
